const CYRILLIC_TO_LATIN = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
  і: 'i',
  ї: 'yi',
  є: 'e',
  ґ: 'g'
};

const SEPARATOR_PATTERN = /[\s\-–—_]+/;
const COMBINING_MARKS_PATTERN = /[\u0300-\u036f]/g;
const QUOTES_PATTERN = /['’`"«»]+/g;
const NON_ALPHANUMERIC_PATTERN = /[^a-z0-9]+/g;

const capitalize = (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const normalizeLoginPart = (value) => {
  if (!value) return [];

  return value
    .trim()
    .split(SEPARATOR_PATTERN)
    .map((segment) =>
      segment
        .normalize('NFKD')
        .replace(COMBINING_MARKS_PATTERN, '')
        .toLowerCase()
        .split('')
        .map((char) => CYRILLIC_TO_LATIN[char] ?? char)
        .join('')
        .replace(QUOTES_PATTERN, '')
        .replace(NON_ALPHANUMERIC_PATTERN, '')
    )
    .filter(Boolean);
};

export const generateLogin = (firstName, lastName) => {
  const firstNameParts = normalizeLoginPart(firstName);
  const lastNameParts = normalizeLoginPart(lastName);

  if (!firstNameParts.length || !lastNameParts.length) {
    return '';
  }

  const firstInitial = firstNameParts[0].charAt(0).toUpperCase();
  const lastNameNormalized = lastNameParts.map(capitalize).join('');

  if (!lastNameNormalized) {
    return '';
  }

  return `${firstInitial}_${lastNameNormalized}`;
};
